import { FC } from "react";
import Quill from "../../../components/common/quill/Quill";
import Button from "../../../components/button/Button";
import { useAppDispatch } from "../../../hooks/redux-hooks";
import { useNavigate } from "react-router-dom";
import { setSEOSettings } from "../../../store/slices/main";

type IProps = {
  icon?: string;
  title?: string;
  description?: string;
  date?: string;
  isCtaButtonActive?: boolean;
  ctaButtonTitle?: string;
  ctaButtonUrl?: string;
  activePublicUrl?: string;
};

const ActiveСontests: FC<IProps> = ({
  icon,
  title,
  description,
  ctaButtonTitle,
  ctaButtonUrl,
  activePublicUrl,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const href = window.location.href.split("/");
  const path = href[href.length - 1];

  const navigateAndSetSEOSettings = async (
    link: string,
    appTitle: string,
    appDescription: string,
    appImg: string,
    publicUrl?: string
  ) => {
    navigate(`${link}`);
    dispatch(
      setSEOSettings({
        appTitle,
        appDescription,
        appImg,
      })
    );
  };

  return (
    <>
      <div className="w-full flex flex-col md:flex-row justify-between items-center md:items-start md:h-[18.75rem]">
        <div className="min-w-[21.25rem] h-auto flex justify-start items-center overflow-hidden rounded-lg md:min-w-[30rem] md:h-[18.75rem] ">
          <img
            onClick={() => {
                navigateAndSetSEOSettings(
                  `${
                    !!path.length
                      ? `${activePublicUrl}`
                      : `contests/${activePublicUrl}`
                  }`,
                  title || "",
                  description || "",
                  icon || "",
                  `${activePublicUrl}`
                );
            }}
            className="w-full h-full object-cover cursor-pointer"
            src={icon}
            alt=""
          />
        </div>
        <div
          className={`h-full flex flex-col items-start justify-between md:pl-7 ${
            ctaButtonUrl ? "" : "md:justify-center"
          }`}
        >
          <div>
            <h3
              onClick={() => {
                  navigateAndSetSEOSettings(
                    `${
                      !!path.length
                        ? `${activePublicUrl}`
                        : `contests/${activePublicUrl}`
                    }`,
                    title || "",
                    description || "",
                    icon || "",
                    `${activePublicUrl}`
                  );
              }}
              className="pt-5 text-2xl text-black font-bold text-ellipsis overflow-hidden line-clamp-2 md:hover:underline cursor-pointer md:pt-0 md:pb-[1rem]"
            >
              {title}
            </h3>
            <p
              className={`py-5 text-base md:py-0 ${
                ctaButtonUrl ? "md:pt-0" : "md:pt-0"
              }`}
            >
              <Quill
                text={description}
                className={`${!!path ? path : "home"} `}
              />
            </p>
          </div>
          {ctaButtonUrl && (
            <Button
              onClick={() => {
                window.open(ctaButtonUrl, "_blank");
              }}
              title={ctaButtonTitle}
              className="text-[#202124] text-white bg-orange transition-opacity hover:opacity-90 hover:transition-opacity"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ActiveСontests;
